const GA_ID = "G-293Z0EQNLG";

let initialized = false;

function dntEnabled() {
  if (typeof navigator === "undefined") return false;
  const dnt =
    navigator.doNotTrack ||
    (typeof window !== "undefined" && window.doNotTrack) ||
    navigator.msDoNotTrack;
  return dnt === "1" || dnt === "yes";
}

export function initAnalytics() {
  if (initialized || typeof window === "undefined") return;
  if (dntEnabled()) return;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  // We fire page_view manually on SPA route changes so the first auto-send
  // doesn't double-count the landing page.
  gtag("config", GA_ID, { send_page_view: false });

  initialized = true;
}

export function trackPageView({ path, title }) {
  if (!initialized || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_title: title,
    page_location: window.location.origin + path,
  });
}

export function trackEvent(name, params = {}) {
  if (!initialized || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", name, params);
}
